export default __webpack_public_path__ + "static/media/ADC2024.9619fb99.jpg";